export default __webpack_public_path__ + "static/media/vi_LGTBIQ.42901751.mp4";